/*
 * Ryan O'Dowd
 * 2024-10-05
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import Button from '@components/common/Button';
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';
import {
  stopMasquerading,
} from '@utils/store/actions';

const MasqueradeIndicator = () => {
  const styles = hooks.useStyles(getStyles);
  const dispatch = hooks.useTypedDispatch();
  const navigation = hooks.useNavigation();

  const userMasqueradingAs = hooks.useTypedSelector((state) => state.userMasqueradingAs);

  if (!userMasqueradingAs) {
    sessionStorage.removeItem('masqueradeAsUserId'); // @TODO: shouldn't need this, but if user isn't in redux, the session variable can be set and not used
    return null;
  }

  return (
    <View style={styles.container}>
      <View style={styles.bottomSection}>
        <Text style={styles.masqueradeText}>Masquerading as: <Text style={styles.name}>{userMasqueradingAs.display_name}</Text></Text>
        <Button
          onPress={() => {
            dispatch(stopMasquerading());
            navigation.navigate('/admin');
          }}
        >
          Stop masquerading
        </Button>
      </View>
    </View>
  );
};

export default MasqueradeIndicator;
